<template>
  <div class="card mb-3">
    <div class="row no-gutters">
      <div class="col-md-12">
        <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
          <div
            class="card-header border-0"
            :class="type === 'dark' ? 'bg-transparent' : ''"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <h3 class="mb-0">Points Adjustment</h3>
                  </div>
                </div>

                <div class="row" v-if="!viewMode">
                  <div class="col">
                    <h6 class="heading-small text-muted">Filter</h6>
                    <a-input-group compact>
                      <a-select v-model="searchType" style="width: 20%">
                        <a-select-option value="mobile_no">
                          Mobile Number
                        </a-select-option>
                        <a-select-option value="name"> Name</a-select-option>
                        <a-select-option value="member_id">
                          Member ID
                        </a-select-option>
                      </a-select>
                      <a-input-search
                        :placeholder="searchPlaceHolder"
                        style="width: 80%"
                        v-model="query"
                        @search="onSearch"
                        :loading="searchLoading"
                        @keypress="inputController"
                      />
                    </a-input-group>
                    <small>
                      <i>
                        <small>{{ example }}</small>
                      </i>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col">
              <div class="row">
                <div class="col">
                  <h6 class="heading-small">Member Details</h6>
                </div>
              </div>
              <div class="d-flex flex-row flex-wrap">
                <div class="w-25 px-1">
                  <h6 class="heading-small text-muted">Member Name</h6>
                  <a-input
                    placeholder="Member Name"
                    v-model="memberName"
                    disabled
                  />
                </div>
                <div class="w-25 px-1">
                  <h6 class="heading-small text-muted">Membership Program</h6>
                  <a-input
                    placeholder=""
                    v-model="memberData.membershipProgramName"
                    disabled
                  />
                </div>

                <div class="w-25 px-1">
                  <h6 class="heading-small text-muted">Membership Level</h6>
                  <a-input
                    placeholder=""
                    v-model="memberData.membershipLevelName"
                    disabled
                  />
                </div>

                <div class="w-25 px-1" v-if="!viewMode">
                  <h6 class="heading-small text-muted">Current Points</h6>
                  <a-input
                    placeholder="0.00"
                    v-model="currentPoints"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <hr class="my-3" />
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col">
                  <h6 class="heading-small">Adjustment Details</h6>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Transaction Type
                  </h6>
                  <a-select
                    id="transaction_type"
                    placeholder="Select transaction type"
                    style="width: 100%"
                    v-model="formData.transaction_type_id"
                    :disabled="viewMode"
                  >
                    <a-select-option
                      v-for="transactionType in options.transactionTypes"
                      :key="transactionType.id"
                      :value="transactionType.id"
                      :data-positive-flag="transactionType.positive_flag"
                      @click="setTransactionFlag"
                    >
                      {{ transactionType.name }}
                      ({{ transactionType.positive_flag ? '+' : '-' }})
                    </a-select-option>
                  </a-select>
                  <div
                    v-if="$v.formData.transaction_type_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.transaction_type_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Store SBU
                  </h6>
                  <a-select
                    placeholder="Select store sbu"
                    style="width: 100%"
                    v-model="formData.company_id"
                    :disabled="viewMode"
                    show-search
                    optionFilterProp="children"
                    @change="onCompanyChange"
                  >
                    <a-select-option
                      v-for="company in options.companies"
                      :key="company.id"
                      :value="company.id"
                    >
                      {{ company.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="$v.formData.company_id.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.company_id.required">
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Store
                  </h6>
                  <a-select
                    placeholder="Select store"
                    style="width: 100%"
                    show-search
                    optionFilterProp="children"
                    v-model="formData.site_id"
                    :disabled="viewMode"
                  >
                    <a-select-option
                      v-for="site in options.sites"
                      :key="site.id"
                      :value="site.id"
                    >
                      {{ site.name }}
                    </a-select-option>
                  </a-select>
                  <div v-if="$v.formData.site_id.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.site_id.required">
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Terminal ID
                  </h6>
                  <a-input
                    placeholder="Terminal ID"
                    v-model="formData.reference_terminal_id"
                    :disabled="viewMode"
                  />
                  <div
                    v-if="$v.formData.reference_terminal_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.reference_terminal_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Transaction ID
                  </h6>
                  <a-input
                    placeholder="Transaction ID"
                    v-model="formData.reference_transaction_id"
                    :disabled="viewMode"
                  />
                  <div
                    v-if="$v.formData.reference_transaction_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.reference_transaction_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Adjustment Reason Type
                  </h6>
                  <a-select
                    placeholder="Select adjustment reason type"
                    style="width: 100%"
                    v-model="formData.adjustment_reason_type_id"
                    :disabled="viewMode"
                  >
                    <a-select-option
                      v-for="reason in options.adjustmentReasonTypes"
                      :key="reason.id"
                      :value="reason.id"
                    >
                      {{ reason.name }}
                    </a-select-option>
                  </a-select>
                  <div
                    v-if="$v.formData.adjustment_reason_type_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.adjustment_reason_type_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Points To Adjust
                  </h6>
                  <a-input
                    placeholder="0.00"
                    v-model="formData.points"
                    :disabled="viewMode"
                  />
                  <small class="text-muted" v-if="!viewMode"
                    >Points after application of adjustments:
                    {{ pointsAfterAdjustment }}</small
                  >
                  <div v-if="$v.formData.points.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.points.required">
                      Field is required
                    </div>
                    <div class="error" v-else-if="!$v.formData.points.decimal">
                      Value must be a valid number
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">Purchase Amount</h6>
                  <a-input
                    placeholder="0.00"
                    v-model="formData.purchase_amount"
                    :disabled="viewMode"
                  />
                  <div
                    v-if="$v.formData.purchase_amount.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.purchase_amount.decimal"
                    >
                      Value must be a valid number
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Transaction Date
                  </h6>
                  <a-date-picker
                    class="w-100"
                    :disabled-date="disabledDate"
                    placeholder="YYYY-MM-DD"
                    :format="dateFormat"
                    :value-format="dateFormat"
                    :disabled="viewMode"
                    v-model="formData.reference_transaction_date"
                  />
                  <div
                    v-if="$v.formData.reference_transaction_date.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.reference_transaction_date.required"
                    >
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <h6 class="heading-small text-muted">
                    <span class="text-danger">*</span> Remarks
                  </h6>
                  <a-textarea
                    placeholder="Remarks"
                    :rows="4"
                    v-model="formData.remarks"
                    :disabled="viewMode"
                  />

                  <div v-if="$v.formData.remarks.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.remarks.required">
                      Field is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2">
                <div class="row">
                  <div class="col-sm-12">
                    <base-input class="mb-0">
                      <a-checkbox
                        v-model="formData.send_sms_notification"
                        :disabled="viewMode"
                        name="check-button"
                      >
                        <label class="form-control-label"
                          >Send SMS Notification</label
                        >
                      </a-checkbox>
                    </base-input>
                    <div v-if="formData.send_sms_notification">
                      <div class="row">
                        <div class="col">
                          <h6 class="heading-small text-muted">
                            <span class="text-danger">*</span> SMS Notification
                            Sending Time
                          </h6>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col" v-if="viewMode">
                          <a-input v-model="smsNotificationTime" disabled />
                        </div>
                        <div class="col" v-else>
                          <base-input>
                            <a-time-picker
                              use12-hours
                              format="h:mm a"
                              @change="smsTimeOnChange"
                              :value="
                                smsNotification.time !== null
                                  ? moment(smsNotification.time, 'hh:mm A')
                                  : null
                              "
                              :disabled="smsNotification.on_demand || viewMode"
                              style="width: 100%"
                            />
                          </base-input>
                          <div
                            v-if="$v.smsNotification.time.$dirty"
                            class="text-danger"
                          >
                            <div
                              class="error"
                              v-if="!$v.smsNotification.time.required"
                            >
                              Field is required
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <a-checkbox
                            :checked="smsNotification.time == null"
                            :value="smsNotification.on_demand"
                            v-model="smsNotification.on_demand"
                            :disabled="!querySuccess"
                          >
                            Send Immediately</a-checkbox
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <hr class="my-3" /> -->
              <div class="row pt-2" v-if="!viewMode">
                <div class="col">
                  <a-button
                    type="primary"
                    :loading="submitLoading"
                    :disabled="!querySuccess"
                    @click="confirmAdjustment"
                  >
                    Submit
                  </a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="members-list-modal" hide-footer hide-header size="lg">
      <div class="d-block">
        <div class="row">
          <div class="col">
            <h2>Members</h2>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Membership Program</th>
                  <th>Name</th>
                  <th>Card number</th>
                  <th>Membership number</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(member, index) in members" :key="index">
                  <td>
                    <span
                      v-if="member.membershipProgram"
                      class="text-wrap"
                      style="width: 6rem"
                    >
                      {{ member.membershipProgram.name }}
                    </span>
                    <span v-else> </span>
                  </td>
                  <td>
                    <span class="text-wrap" style="width: 6rem"
                      >{{ member.first_name }} {{ member.last_name }}</span
                    >
                  </td>
                  <td>
                    <span v-if="member.card">
                      {{ member.card.card_number }}
                    </span>
                    <span v-else> </span>
                  </td>
                  <td>{{ member.membership_number }}</td>
                  <td>
                    <b-button
                      class="mt-3 float-end btn-sm"
                      variant="success"
                      @click="selectedMember(member)"
                      >Select</b-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <hr class="mt-1 mb-1" />
      <div class="col">
        <div class="d-flex justify-content-end">
          <b-button
            class="mt-3 float-end w-25 btn-sm"
            variant="secondary"
            @click="$bvModal.hide('members-list-modal')"
            >Cancel</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required, decimal, requiredIf } from 'vuelidate/lib/validators';
import secureStorage from '../../controllers/secureStorage';
import moment from 'moment-timezone';

const ENV = process.env.VUE_APP_ENV;
let TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  name: 'PointsAdjustmentForm',
  props: {
    pointsAdjustmentData: Object,
    viewMode: Boolean,
    type: String,
    drawerVisible: Boolean
  },
  components: {},
  data() {
    return {
      searchType: 'member_id',
      searchLoading: false,
      dateFormat: 'YYYY-MM-DD',
      submitLoading: false,
      query: null,
      querySuccess: false,
      transactionFlag: false,
      members: [],
      searchPlaceHolder: 'Member ID',
      example: 'Member ID (e.g. PRIMER-12345567)',
      memberData: {
        firstname: '',
        lastname: '',
        membershipProgramId: '',
        membershipLevelId: '',
        currentPointsBalanceExpiring: 0,
        currentPointsBalanceActive: 0
      },
      notification: {
        title: null,
        message: null,
        smsNotification: false,
        appNotification: false,
        image: null,
        image_url: null,
        sending_time: null,
        is_same_or_before: false
      },
      formData: {
        membership_program_id: null,
        member_id: null,
        send_sms_notification: false,
        mobile_number: null,
        transaction_type_id: null,
        adjustment_reason_type_id: null,
        points: null,
        purchase_amount: null,
        remarks: null,
        reference_transaction_date: null,
        sms_date_time_sent: null,
        company_id: null,
        site_id: null,
        reference_terminal_id: null,
        reference_transaction_id: null
      },
      smsNotification: {
        on_demand: false,
        time: null,
        is_same_or_before: false,
        time_object: null
      },
      options: {
        transactionTypes: [],
        adjustmentReasonTypes: [],
        membershipPrograms: [],
        membershipLevels: [],
        companies: [],
        sites: []
      }
    };
  },

  validations: {
    formData: {
      transaction_type_id: { required },
      adjustment_reason_type_id: { required },
      company_id: { required },
      site_id: { required },
      points: { required, decimal },
      purchase_amount: { decimal },
      remarks: { required },
      reference_terminal_id: { required },
      reference_transaction_id: { required },
      reference_transaction_date: {
        required
      }
    },
    smsNotification: {
      time: {
        required: requiredIf(function () {
          return (
            !this.smsNotification.on_demand &&
            this.formData.send_sms_notification
          );
        })
      }
    }
  },

  methods: {
    async selectedMember(member) {
      this.memberData = {
        firstname: member.first_name,
        lastname: member.last_name,
        membershipProgramName: member.membershipProgram.name,
        membershipLevelName: member.membershipLevel.name,
        membershipProgramId: member.membership_program_id,
        membershipLevelId: member.membership_level_id,
        currentPointsBalanceExpiring: member.current_points_balance_expiring,
        currentPointsBalanceActive: member.current_points_balance_active
      };

      this.formData.member_id = member.id;
      this.formData.membership_program_id = member.membership_program_id;
      this.formData.mobile_number = member.mobile_no;

      await this.getAdjustmentReasonTypes(member.membership_program_id);
      await this.getCompanies();

      this.$bvModal.hide('members-list-modal');
    },
    moment,
    setTransactionFlag(el) {
      const positiveFlag = el.item.$el.dataset.positiveFlag == 1 ? true : false;
      this.transactionFlag = positiveFlag;
    },
    isTimeInPast(targetTime) {
      const currentTime = moment();
      const targetMoment = moment(targetTime, 'h:mm a');
      this.smsNotification.is_same_or_before =
        targetMoment.isSameOrBefore(currentTime);
    },

    disabledDate(current) {
      return current > moment().endOf('day');
    },

    smsTimeOnChange(time, timeString) {
      this.smsNotification.time = timeString;
      this.smsNotification.time_object = timeString;
      this.isTimeInPast(timeString);
    },
    validatePhoneNumber(number) {
      const regex = /^(09|\+639)\d{9}$/; // regular expression pattern for Philippine phone numbers
      return regex.test(number);
    },
    async onSearch() {
      if (this.query !== null) {
        if (
          this.searchType == 'mobile_no' &&
          !this.validatePhoneNumber(this.query)
        ) {
          this.$notification.error({
            message:
              'Validation failed: Please check the inputted phone number.'
          });
          return;
        }
        let type = this.searchType;
        let urlParam = '';
        if (this.searchType == 'name') {
          type = 'full_name';
          const search = this.query.split('/');
          if (typeof search[0] != 'undefined') {
            urlParam += '&first_name=' + search[0].trim();
          }
          if (typeof search[1] != 'undefined') {
            urlParam += '&last_name=' + search[1].trim();
          }
        }
        this.searchLoading = true;
        const response = await HTTPRequest.getRequest(
          '/api/v1/clp_members/search?type=' +
            type +
            '&search=' +
            this.query +
            '&allow_multiple=' +
            true +
            urlParam
        );
        if (response.id) {
          this.memberData = {
            firstname: response.first_name,
            lastname: response.last_name,
            membershipProgramName: response.membershipProgram.name,
            membershipLevelName: response.membershipLevel.name,
            membershipProgramId: response.membership_program_id,
            membershipLevelId: response.membership_level_id,
            currentPointsBalanceExpiring:
              response.current_points_balance_expiring,
            currentPointsBalanceActive: response.current_points_balance_active
          };

          this.formData.member_id = response.id;
          this.formData.membership_program_id = response.membership_program_id;
          this.formData.mobile_number = response.mobile_no;

          await this.getAdjustmentReasonTypes(response.membership_program_id);
          await this.getCompanies();

          this.querySuccess = true;
        } else {
          if (response.length >= 1) {
            if (response.length === 1) {
              this.memberData = {
                firstname: response[0].first_name,
                lastname: response[0].last_name,
                membershipProgramName: response[0].membershipProgram.name,
                membershipLevelName: response[0].membershipLevel.name,
                membershipProgramId: response[0].membership_program_id,
                membershipLevelId: response[0].membership_level_id,
                currentPointsBalanceExpiring:
                  response[0].current_points_balance_expiring,
                currentPointsBalanceActive:
                  response[0].current_points_balance_active
              };

              this.formData.member_id = response[0].id;
              this.formData.membership_program_id =
                response[0].membership_program_id;
              this.formData.mobile_number = response[0].mobile_no;

              await this.getAdjustmentReasonTypes(
                response[0].membership_program_id
              );
              await this.getCompanies();
            } else {
              this.members = response;
              this.$bvModal.show('members-list-modal');
            }
            this.querySuccess = true;
          } else {
            if (response.error != undefined) {
              this.$notification.error({
                message: response.error
              });
            } else {
              this.$notification.error({
                message: 'Something went wrong. Please try again.'
              });
            }
            this.resetData();
            this.querySuccess = false;
          }
        }

        this.searchLoading = false;
      }
    },

    async onSubmit() {
      this.$v.formData.$touch();
      this.$v.smsNotification.$touch();
      if (!this.$v.formData.$invalid && !this.$v.smsNotification.$invalid) {
        this.submitLoading = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_transactions/points_adjustment?origin_site_id=' +
            secureStorage.getItem('currentSiteId'),
          { transaction: this.formData, sms_notification: this.smsNotification }
        );

        if (response.message != undefined && response.message == 'Success') {
          this.$emit('closeDrawer', null);
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Points has been adjusted.'
          });

          this.resetData();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.submitLoading = false;
      }
    },

    confirmAdjustment() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to make this adjustment?',
        onOk: () => {
          this.onSubmit();
        }
      });
    },

    async getTransactionTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_transaction_types?manual_flag=1'
      );

      this.options.transactionTypes = response.data;
    },

    async getAdjustmentReasonTypes(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/adjustment_reason_types`
      );
      this.options.adjustmentReasonTypes = data;
    },

    async getCompanies() {
      const response = await HTTPRequest.getRequest(`/api/v1/companies`);
      this.options.companies = response.data;
    },

    async onCompanyChange(data) {
      await this.getSites(data);
    },

    async getSites(companyId) {
      if (companyId) {
        const response = await HTTPRequest.getRequest(
          `/api/v1/companies/${companyId}/sites`
        );

        this.options.sites = response.data;
      }
    },

    inputController(e) {
      let regEx;
      if (this.searchType == 'mobile_no') {
        regEx = /[0-9+]+/;

        if (!regEx.test(e.key)) {
          return e.preventDefault();
        }
      }
    },

    isJsonString(str) {
      try {
        let json = JSON.parse(str);
        return typeof json === 'object';
      } catch (e) {
        return false;
      }
    },
    smsDateTimeSentformatter(date) {
      if (moment(date).isValid()) {
        if (ENV === 'development') {
          return moment(date).format('hh:mm A');
        } else {
          return moment.tz(date, TIMEZONE).utc().format('hh:mm A');
        }
      }
      return null;
    },
    resetData() {
      this.memberData = {
        firstname: '',
        lastname: '',
        membershipProgramId: '',
        membershipLevelId: '',
        membershipProgramName: '',
        membershipLevelName: '',
        currentPointsBalanceExpiring: 0,
        currentPointsBalanceActive: 0
      };
      this.formData = {
        send_sms_notification: false,
        membership_program_id: null,
        member_id: null,
        mobile_number: null,
        transaction_type_id: null,
        adjustment_reason_type_id: null,
        points: null,
        purchase_amount: null,
        remarks: null,
        company_id: null,
        site_id: null,
        reference_terminal_id: null,
        reference_transaction_id: null
      };

      this.smsNotification = {
        on_demand: false,
        is_same_or_before: false,
        time: null
      };

      this.query = null;
      this.querySuccess = false;

      this.$v.formData.$reset();
      this.$v.smsNotification.$reset();
    },

    setFormData(data = null) {
      if (data != null) {
        let {
          membership_program_id,
          member_id,
          transaction_type_id,
          adjustment_reason_type_id,
          points,
          purchase_amount,
          remarks,
          send_sms_notification,
          sms_date_time_sent,
          reference_transaction_date,
          transactionType,
          company_id,
          site_id,
          reference_terminal_id,
          reference_transaction_id
        } = data;

        const {
          first_name,
          last_name,
          membership_level_id,
          mobile_number,
          membership_level_name
        } = data.member;
        this.getAdjustmentReasonTypes(membership_program_id);
        this.getCompanies();
        this.getSites(company_id);

        if (reference_transaction_date) {
          reference_transaction_date = moment(
            reference_transaction_date
          ).format('YYYY-MM-DD');
        } else {
          reference_transaction_date = null;
        }

        this.formData = {
          membership_program_id,
          member_id,
          mobile_number,
          transaction_type_id,
          adjustment_reason_type_id,
          points,
          purchase_amount,
          reference_transaction_date,
          remarks,
          company_id,
          site_id,
          reference_terminal_id,
          reference_transaction_id
        };

        let enable_notification =
          send_sms_notification === 1 || sms_date_time_sent !== null;

        if (this.isJsonString(data.extras)) {
          const extras = JSON.parse(data.extras);
          if (extras) {
            if (
              (extras &&
                extras.smsNotification &&
                extras.smsNotification == 'true') ||
              (extras.appNotification && extras.appNotification == 'true')
            ) {
              enable_notification = true;
              sms_date_time_sent =
                extras.sending_time == 'null' ? '' : extras.sending_time;
            }
          }
        }

        if (transactionType.positive_flag) {
          this.transactionFlag = true;
        } else {
          this.transactionFlag = false;
        }

        console.log('Enable Notification:', enable_notification);
        // this.formData.send_sms_notification = enable_notification
        //  ? true
        //  : false;

        this.formData.send_sms_notification = send_sms_notification;
        this.smsNotification.on_demand = sms_date_time_sent === '';
        this.smsNotification.time = sms_date_time_sent;
        this.memberData = {
          firstname: first_name,
          lastname: last_name,
          membershipLevelName: membership_level_name,
          membershipProgramName: data.membershipProgram.name,
          membershipProgramId: membership_program_id,
          membershipLevelId: membership_level_id
        };
      } else {
        this.resetData();
      }
    }
  },

  created() {
    this.getTransactionTypes();
    this.setFormData(this.pointsAdjustmentData);

    console.log('moment.tz.guess(): ', moment.tz.guess());
  },

  computed: {
    smsNotificationTime() {
      const smsTime = this.smsNotification.time;
      if (smsTime) {
        const momentTime = moment(smsTime, 'h:mm a');
        if (momentTime.isValid()) {
          return moment(smsTime).tz(TIMEZONE).format('hh:mm A');
        }
      }
      return null;
    },
    memberName() {
      return this.memberData.firstname + ' ' + this.memberData.lastname;
    },

    currentPoints() {
      return (
        parseFloat(this.memberData.currentPointsBalanceExpiring) +
        parseFloat(this.memberData.currentPointsBalanceActive)
      );
    },

    pointsAfterAdjustment() {
      let currentPoints = this.currentPoints;
      let transactionFlag = this.transactionFlag;
      let points = this.formData.points;
      let ret;

      // if (currentPoints != 0) {
      if (transactionFlag) {
        ret = parseFloat(currentPoints) + Math.abs(parseFloat(points));
      } else {
        ret = parseFloat(currentPoints) + Math.abs(parseFloat(points)) * -1;
      }

      return isNaN(ret) ? '-' : ret;
    }
  },

  watch: {
    searchType: function (currentSearch) {
      switch (currentSearch) {
        case 'name':
          this.searchPlaceHolder = 'First Name / Last Name';
          this.example = 'First Name / Last Name (e.g. John / Doe)';
          this.query = null;
          break;
        case 'mobile_no':
          this.searchPlaceHolder = 'Mobile Number';
          this.example = 'Mobile Number (e.g. +639123456789)';
          this.query = null;
          break;
        case 'member_id':
          this.searchPlaceHolder = 'Member ID';
          this.example = 'Member ID (e.g. PRIMER-12345567)';
          this.query = null;
          break;
      }
    },

    pointsAdjustmentData: function (data) {
      console.log('pointsAdjustmentData', data);
      this.setFormData(data);
    },

    'smsNotification.on_demand': function (val) {
      if (val) {
        this.smsNotification.time = null;
        this.smsNotification.on_demand = val;
      }
    },

    'formData.send_sms_notification': function (val) {
      if (val) {
        this.formData.send_sms_notification = val;
      }
    }
  }
};
</script>

<style scoped></style>
